import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchHandoverData = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_post_op_handover/${uhidNo}`);
  return response.data;
};

export const fetchNextIpNo = async () => {
  const response = await axios.get(`${API_BASE_URL}/postop_handover_next_ip`);
  return response.data;
};

export const submitHandover = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}/submit_post_op_handover`, payload);
  return response.data;
};

export const updateHandover = async (uhidNo, payload) => {
  const response = await axios.put(`${API_BASE_URL}/update_post_op_handover/${uhidNo}`, payload);
  return response.data;
};

export const generateShareToken = async (uhidNo) => {
  const response = await axios.post(`${API_BASE_URL}/generate_for_post_op_handover_share_token/${uhidNo}`);
  return response.data;
};
